<div class="burger-menu" [class.active]="active()">
	<button
		type="button"
		class="burger-icon no-default"
		i18n-aria-label="@@menu.toggle"
		aria-label="Toggle menu"
		(click)="toggleBurgerMenu()"
	>
		<span class="burger-line"></span>
	</button>

	<div class="burger-container mos-scrollbar">
		<nav>
			<a (click)="closeMenu()" routerLink="/" routerLinkActive="active">
				@if (!configService.isPreregister()) {
					<span i18n="@@landing.nav.preregistration">Inscription</span>
				} @else {
					<span i18n="@@landing.nav.registration">Pré-inscription</span>
				}
				<span class="mos-line"></span>
			</a>
			<a (click)="closeMenu()" routerLink="/story">
				<span i18n="@@landing.nav.story">L'histoire</span>
				<span class="mos-line"></span>
			</a>
			<a (click)="closeMenu()" routerLink="/npcs">
				<span i18n="@@landing.nav.npcs">Les personnages</span>
				<span class="mos-line"></span>
			</a>
			<a (click)="closeMenu()" routerLink="/game">
				<span i18n="@@landing.nav.game">Le jeu</span>
				<span class="mos-line"></span>
			</a>
			<a (click)="closeMenu()" routerLink="/team">
				<span i18n="@@landing.nav.team">L'équipe</span>
				<span class="mos-line"></span>
			</a>
			<a (click)="closeMenu()" routerLink="/faq">
				<span i18n="@@landing.nav.faq"> FAQ</span>
				<span class="mos-line"></span>
			</a>
		</nav>

		@if (configService.isPreregister()) {
			<mos-button
				(mosClick)="closeMenu()"
				routerLink="/register"
				class="mos-landing-login-button"
				type="button"
				i18n="@@landing.preregister"
			>
				Se préinscrire
			</mos-button>
		} @else {
			<mos-button
				(mosClick)="closeMenu()"
				routerLink="/login"
				class="mos-landing-login-button"
				type="button"
				i18n="@@landing.play"
			>
				Jouer
			</mos-button>
		}

		<picture>
			<source type="image/avif" srcset="/assets/images/landing/logo.avif" />
			<source type="image/webp" srcset="/assets/images/landing/logo.webp" />
			<source type="image/png" srcset="/assets/images/landing/logo.png" />
			<img
				i18n-alt="@@landing.logo.alt"
				alt="Logo {{ configService.getDisplayName() }}"
				ngSrc="/assets/images/landing/logo.png"
				priority="true"
				[width]="logo.landing.width"
				[height]="logo.landing.height"
				class="logo"
			/>
		</picture>

		<mos-social-links></mos-social-links>
	</div>
</div>
